import { useStoryblokApi } from "@storyblok/vue";

const STORYBLOK_URL = 'cdn/stories/ecommerce-homepage';

export default function () {
  function getVersion() {
    const params = new URLSearchParams(location.search);

    let version = "published";

    if (params.has("_storyblok")) {
      version = "draft";
    }

    return version;
  }

  async function getStoryBlokData() {
    const storyblokApi = useStoryblokApi();

    return await storyblokApi.get(STORYBLOK_URL, {
      version: getVersion(),
    });
  }


  return { getStoryBlokData };
}
